import React from 'react';
import './Layout.scss';

const Layout = ({ children }) => (
  <div className="c-layout">
    <div className="c-layout__wrapper">
      <div className="c-layout__inner">{children}</div>
    </div>
  </div>
);

const Sidebar = ({ children }) => (
  <div className="c-layout-sidebar">
    <div className="c-layout-sidebar__inner">
      {children}
    </div>
  </div>
);

const Main = ({ children }) => (
  <div className="c-layout-main">
    {children}
  </div>
);

const Content = ({ children }) => (
  <div className="c-layout-content">
    {children}
  </div>
);

Layout.Sidebar = Sidebar;
Layout.Main = Main;
Layout.Content = Content;

export { Layout };
